export default {
  Contract: 'عقد',
  'To generate the contract please press the button below.':
    'لإنشاء العقد، يرجى الضغط على الزر أدناه.',
  'Generate contract': 'إنشاء العقد',
  'Review the generated document and upload the signed contract photos in the area below.':
    'يرجى مراجعة المستند الذي تم إنشاؤه وإرفاق صور العقد الموقعة في المنطقة أدناه.',
  'Download contract': 'تحميل العقد',
  'Sign and submit': 'التوقيع وتقديم',
  'Authorised signatory': 'الموقعون المعتمدون',
  'Feel free to select another authorised signatory. Contract will be re-generated with new data.':
    'لا تتردد في اختيار موقع معتمد آخر. سيتم إعادة إنشاء العقد ببيانات جديدة.',
  'Choose another person': 'اختر شخصًا آخر',
  'Choose person': 'اختر الشخص',
  'Send invitation': 'إرسال دعوة',
  'Resend invitation': 'إعادة إرسال الدعوة',
  'View contract': 'عرض العقد',
  'Send invitation to:': 'إرسال دعوة إلى:',
  'We will send the invitation link to log in to the Portal.':
    'سنرسل رابط الدعوة لتسجيل الدخول إلى البوابة.',
  'Who will sign the contract?': 'من سيقوم بتوقيع العقد؟',
  'Select authorised signatory': 'حدد الموقع المعتمد',

  // TODO: Add Nafath translations below:
  'To successfully submit the signed agreement, please do not reload the page or close the tab until the end of the authentication process. Any uploaded documents will be lost if the page is reloaded, or the tab is closed.':
    'لإرسال الاتفاقية الموقعة بنجاح، يُرجى عدم إعادة تحميل الصفحة أو إغلاق علامة التبويب حتى انتهاء عملية التحقق. ستفقد أي مستندات تم تحميلها إذا تمت إعادة تحميل الصفحة أو إغلاق علامة التبويب.',
  'To submit the contract, please complete the Nafath biometric authentication process. Ensure you have access to the Nafath application and press the “Continue” button below when you are ready to proceed.':
    'لإرسال العقد، يُرجى إكمال عملية التحقق البيومتري عبر نافذ. تأكد من وصولك إلى تطبيق نافذ واضغط على زر "متابعة" أدناه عندما تكون مستعدًا للمتابعة.',
  'Submitting contract': 'جارٍ إرسال العقد',
  'You rejected the Network International Arabia request in the Nafath application. Please try again to proceed.':
    'لقد رفضت طلب Network International Arabia في تطبيق نافذ. يُرجى المحاولة مرة أخرى للمتابعة.',
  'You rejected the request in Nafath. Please try again.': 'تم رفض الطلب عبر نفاذ. يرجى المحاولة مرة أخرى.',
  'You have {{count}} attempts left._one': 'لديك {{count}} محاولة متبقية.',
  'You have {{count}} attempts left._other': 'لديك {{count}} محاولات متبقية.',
  'The Nafath biometric authentication retry is temporary locked. Please wait before trying again.':
    'تم قفل إعادة محاولة التحقق البيومتري عبر نافذ مؤقتًا. يُرجى الانتظار قبل المحاولة مرة أخرى.',
  'The Nafath biometric authentication session is expired. Please try again to proceed.':
    'انتهت صلاحية جلسة التحقق البيومتري عبر نافذ. يُرجى المحاولة مرة أخرى للمتابعة.',
  'The Nafath authentication session has expired. Please try again.': 'انتهت صلاحية جلسة التحقق عبر نفاذ. يرجى إعادة المحاولة.',
  'Please <1>Contact us</1> or try again later.': 'يرجى <1>الاتصال بنا</1> أو المحاولة لاحقًا.',
  'The Nafath biometric authentication retry limits have been reached and your account is permanently locked. <1>Contact us</1> to unlock your account.':
    'تم الوصول إلى الحد الأقصى لمحاولات التحقق البيومتري عبر نافذ وتم قفل حسابك بشكل دائم. <1>اتصل بنا</1> لفتح حسابك.',
  'Please generate the contract to proceed.': 'يرجى إنشاء العقد للمتابعة.',
  'Please accept the Network International Arabia request in the Nafath application and match the number displayed below with the one shown in the app.':
    'يرجى قبول طلب Network International Arabia في تطبيق نافذ ومطابقة الرقم المعروض أدناه مع الرقم المعروض في التطبيق.',
  'Reset counter': 'إعادة ضبط العداد',
  '{{attemptsUsed}} out of {{attemptsMax}}': '{{attemptsUsed}} من أصل {{attemptsMax}}',
  'Your request session will expire in': 'ستنتهي صلاحية جلسة طلبك في',
  'Try again to complete the authentication in': 'حاول مرة أخرى لإكمال عملية التحقق خلال',
  'Full name': 'الاسم الكامل',
  'Current signature': 'التوقيع الحالي',
  Counter: 'عداد',
  'Are you sure?': 'هل أنت متأكد؟',
  'Do you want to reset couner for {{name}}?': 'هل تريد إعادة ضبط العداد لـ {{name}}؟',
  // End of Nafath translations

  // ── Agreement pricing amendment (NASSC-19394) ──
  'Amend Agreement Pricing': 'تعديل تسعير الاتفاقية',
  'Submit for approval': 'إرسال للموافقة',
  Minimum: 'الحد الأدنى',
  'Percentage only': 'نسبة مئوية فقط',
  'Fixed only': 'مبلغ ثابت فقط',
  'Percentage + Fixed': 'نسبة مئوية + مبلغ ثابت',
  'Percentage plus fixed': 'نسبة مئوية + مبلغ ثابت',
  'This field is required.': 'هذا الحقل مطلوب.',
  'Enter a whole number — decimals are not allowed.':
    'أدخل رقماً صحيحاً — الكسور العشرية غير مسموح بها.',
  'Must be at least {{min}} {{currency}}.':
    'يجب أن يكون على الأقل {{min}} {{currency}}.',
  'Must be at least {{min}}%.': 'يجب أن يكون على الأقل {{min}}%.',
  'Both fields are below the minimum — at least {{minP}}% and {{min}} {{currency}}.':
    'كلا الحقلين أقل من الحد الأدنى — على الأقل {{minP}}% و {{min}} {{currency}}.',
  'Percentage must be at least {{min}}%.':
    'يجب أن تكون النسبة المئوية على الأقل {{min}}%.',
  'Amount must be at least {{min}} {{currency}}.':
    'يجب أن يكون المبلغ على الأقل {{min}} {{currency}}.',
  'Value is required': 'القيمة مطلوبة',
  'Value must be a whole number (INTEGER)': 'يجب أن تكون القيمة رقمًا صحيحًا',
  'Value is not within the acceptable range. Minimum: {{min}} {{currency}}':
    'القيمة خارج النطاق المقبول. الحد الأدنى: {{min}} {{currency}}',
  'Value is not within the acceptable range. Minimum: {{min}}%':
    'القيمة خارج النطاق المقبول. الحد الأدنى: {{min}}%',
  'Value is not within the acceptable range. Minimum: {{minP}}% + {{min}} {{currency}}':
    'القيمة خارج النطاق المقبول. الحد الأدنى: {{minP}}% + {{min}} {{currency}}',
  'Pricing submitted for Sales Manager approval':
    'تم إرسال التسعير للحصول على موافقة مدير المبيعات',
  'Failed to submit pricing': 'فشل إرسال التسعير',
  'Pricing submitted and pending Sales Manager approval. Fields are locked until a decision is made.':
    'تم إرسال التسعير وهو بانتظار موافقة مدير المبيعات. الحقول مقفلة حتى اتخاذ القرار.',
  'Pricing approved. Fields are locked.': 'تمت الموافقة على التسعير. الحقول مقفلة.',
  'Pricing approved. You may still amend fees and resubmit for another review.':
    'تمت الموافقة على التسعير. لا يزال يمكنك تعديل الرسوم وإعادة الإرسال لمراجعة أخرى.',
  'Pricing was rejected. You may amend and resubmit.':
    'تم رفض التسعير. يمكنك التعديل وإعادة الإرسال.',
  'Agreement pricing is not available for this application.':
    'تسعير الاتفاقية غير متاح لهذا الطلب.',
  'No editable pricing fields available for the selected product(s).':
    'لا توجد حقول تسعير قابلة للتعديل للمنتج (المنتجات) المحددة.',
  'Pricing submitted and pending approval. You may amend and resubmit, or approve.':
    'تم إرسال التسعير وهو بانتظار الموافقة. يمكنك التعديل وإعادة الإرسال، أو الموافقة.',
  'Pricing submitted and pending approval. You may amend fees before approving or rejecting.':
    'تم إرسال التسعير وهو بانتظار الموافقة. يمكنك تعديل الرسوم قبل الموافقة أو الرفض.',
  'Pricing submitted and pending Sales Manager approval. You may amend and resubmit.':
    'تم إرسال التسعير وهو بانتظار موافقة مدير المبيعات. يمكنك التعديل وإعادة الإرسال.',
  Approve: 'موافقة',
  Reject: 'رفض',
  'Approve or reject': 'موافقة أو رفض',
  'Reason for rejection': 'سبب الرفض',
  'A rejection reason is required': 'سبب الرفض مطلوب',
  'Pricing approved. The merchant has been notified.':
    'تمت الموافقة على التسعير. تم إخطار التاجر.',
  'Failed to approve pricing': 'فشل في الموافقة على التسعير',
  'Failed to reject pricing': 'فشل في رفض التسعير',
  'Pricing rejected. The amendment has been returned to the agent.':
    'تم رفض التسعير. تم إعادة التعديل إلى الوكيل.',
  'Credit Card fee type': 'نوع رسوم بطاقة الائتمان',

  // ── Agreement pricing field labels ──
  POS: 'نقاط البيع',

  ECOM: 'التجارة الإلكترونية',

  Ecom: 'التجارة الإلكترونية',
  setupFee: 'رسوم الإعداد',
  monthlyFee: 'الرسوم الشهرية',
  madaTransactionsLessThan100: 'معاملات مدى أقل من 100 ريال سعودي',
  madaTransactions100OrAbove: 'معاملات مدى 100 ريال سعودي أو أكثر',
  madaPerTransaction: 'مدى (لكل معاملة)',
  gccCardsPerTransaction: 'بطاقات دول مجلس التعاون الخليجي لكل معاملة',
  creditCardPerTransaction: 'بطاقة الائتمان لكل معاملة',
  minimumUsageFeePerPosDevice:
    'الحد الأدنى لرسوم الاستخدام لكل جهاز نقاط البيع (إذا كانت قيمة المبيعات الشهرية أقل من 15,000 ريال سعودي)',
  fundsTransferFees: 'رسوم تحويل الأموال',
  fundsTransferFee: 'رسوم تحويل الأموال',

  // ── Agent Contract View ──
  Agreement: 'الاتفاقية',
  'Signatory Details': 'تفاصيل الموقع',
  'Signatory Name': 'اسم الموقع',
  'Signatory National ID': 'الهوية الوطنية للموقع',
  'Signatory IP Address': 'عنوان IP للموقع',
  'Applicant Details': 'تفاصيل مقدم الطلب',
  'Applicant Name': 'اسم مقدم الطلب',
  'Applicant Mobile Number': 'رقم جوال مقدم الطلب',
  'Applicant National ID': 'الهوية الوطنية لمقدم الطلب',
  'Agreement Details': 'تفاصيل الاتفاقية',
  'Signed Contract': 'العقد الموقع',
  'File Name': 'اسم الملف',
  'Contract Version Number': 'رقم إصدار العقد',
  'Agreement Acceptance Date & Time': 'تاريخ ووقت قبول الاتفاقية',
  'Nafath Verification Date & Time': 'تاريخ ووقت التحقق عبر نفاذ',
  'Contract Reviewed by Agent': 'تمت مراجعة العقد بواسطة الوكيل',
  'Upload File': 'تحميل الملف',
  Confirm: 'تأكيد',
};
